// extracted by mini-css-extract-plugin
module.exports = {"related-stories":"relatedStoriesWithImageRight-m__related-stories__2u_ym","related-stories-section":"relatedStoriesWithImageRight-m__related-stories-section__ykx2C"};